export var SlugId;
(function (SlugId) {
    SlugId["RequiredFieldsMustBeValid"] = "requiredFieldsMustBeValid";
    SlugId["InvalidUsername"] = "invalidUsername";
    SlugId["InvalidEmailFormat"] = "invalidEmailFormat";
    SlugId["AgreementRequired"] = "agreementRequired";
    SlugId["UsernameHint"] = "usernameHint";
    SlugId["InvalidUsernameOrEmailMessage"] = "invalidUsernameOrEmailMessage";
    SlugId["EmailExistsMessage"] = "emailExistsMessage";
    SlugId["Cooldown"] = "cooldown";
    SlugId["Min"] = "min";
    SlugId["Sec"] = "sec";
    SlugId["ResendIn"] = "resendIn";
    SlugId["ResendCode"] = "resendCode";
})(SlugId || (SlugId = {}));
export class Slugs {
    constructor() {
        if (!window.slugs) {
            console.debug("Missing slugs macro!");
            return;
        }
        this.translatedSlugs = window.slugs;
        this.assertSlugs();
        delete window.slugs;
    }
    assertSlugs() {
        for (const key in SlugId) {
            if (!this.translatedSlugs?.[SlugId[key]]) {
                console.debug("Missing slug-data for:", key);
            }
        }
    }
    static init() {
        if (!Slugs.instance) {
            Slugs.instance = new Slugs();
        }
    }
    static get translated() {
        return Slugs.instance.translatedSlugs;
    }
}
